import {getFrom, compose} from '@pluto/utils';
import {createSelector} from 'reselect';

interface State {
    textEnums: {
        ratings: {[key: string]: string}
    }
}

const selectSelf = (state: State) => state;

export const selectRatings = createSelector(
    selectSelf,
    compose(getFrom('ratings'), getFrom('textEnums')),
);
